import { render } from "./FilterATSalesmanSalesman.vue?vue&type=template&id=5134e00a"
import script from "./FilterATSalesmanSalesman.vue?vue&type=script&lang=js"
export * from "./FilterATSalesmanSalesman.vue?vue&type=script&lang=js"
script.render = render

export default script